import { http, providerApi } from '@/core/api/';
//Constants
import codeViewTypes from '@/utils/constants/comment/CodeViewTypes';
import serviceTypes from '@/utils/constants/service-types';
import academicYearService from '../common/academicyear.api';
import codeService from '@/modules/common/code.api';
import categories from '@/utils/constants/categoriesFlag';
const apiUrl = 'api/studentreferrals';

export default {
  //Temp (make extion)
  sortBy(collection) {
    return collection.sort(function(a, b) {
      let nameA = a?.name?.toUpperCase(); // ignore upper and lowercase
      let nameB = b?.name?.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  },
  async getThrpyReferrals(filter) {
    let response = await http.get(`${apiUrl}/thrpyreferrals`, {
      params: filter,
    });

    if (response.data) {
      return response.data;
    }
    return [];
  },
  async getthrpyreferraldetails(admisionid) {
    const { status, data } = await http.get(
      `${apiUrl}/getthrpyreferraldetails/${admisionid}`
    );
    if (status != 200) return [];
    return data;
  },
  // Filters
  // Standard & Advanced
  async getAdmissionStatus() {
    const { status, data } = await http.get(
      'api/thrpyadmission/GetAdmissionStatus'
    );
    if (status != 200) return [];
    return data;
  },
  async getAdmissionStatusReasons(id) {
    const { status, data } = await http.get(
      'api/thrpyadmission/AdmissionStatusReason',
      {
        params: {
          admissionStatusId: id,
        },
      }
    );
    if (status != 200) return [];
    return data;
  },
  async getAdmissionReferralTypes() {
    const { status, data } = await http.get(
      'api/thrpyadmission/GetAdmissionReferralTypes'
    );
    if (status != 200) return [];
    return data;
  },
  async getServiceModalityTypes() {
    const { status, data } = await http.get(
      'api/thrpyadmission/servicemodalitytypes'
    );
    if (status != 200) return [];
    return data;
  },
  //Filters Advanced & Waiting List
  async getDisciplineTypes() {
    return await codeService.getDisciplineTypes({
      serviceTypeIds: [serviceTypes.Terapia],
      categories: [categories.validForEncuentro],
    });
  },
  //Filters Advanced
  async getAvailableMonthsByAcademicYear(academicYearId) {
    return await academicYearService.getAvailableMonths(academicYearId);
  },
  async getCompaniesByAcademicyearId(academicYearId, centerId) {
    try {
      const { data } =
        centerId == undefined
          ? await http.get(`api/provider/${academicYearId}`)
          : await http.get(`api/provider/${academicYearId}/${centerId}`);
      if (data) {
        return data;
      }
      return [];
    } catch {
      return [];
    }
  },
  async getCenters(academicyearId, providerId) {
    const { status, data } = await http.get(
      `api/provider/${academicyearId}/centers/${providerId}`
    );
    if (status != 200) return [];
    return this.sortBy(data);
  },
  async getMunicipalities(academicyearId, providerId, centerId) {
    const { status, data } = await http.get(
      `api/provider/${academicyearId}/municipalities/`,
      {
        params: {
          providerId: providerId,
          centerId: centerId,
        },
      }
    );
    if (status != 200) return [];
    return this.sortBy(data);
  },
  async getLocationTypes() {
    return await codeService.getLocationTypes(codeViewTypes.ReferralManagment);
  },
  async getLocationServices(
    academicyearId,
    providerId,
    centerId,
    municipalityId,
    locationtypeId
  ) {
    const { status, data } = await http.get(
      `api/provider/${academicyearId}/locationServices/`,
      {
        params: {
          providerId: providerId,
          centerId: centerId,
          municipalityId: municipalityId,
          locationtypeId: locationtypeId,
        },
      }
    );
    if (status != 200) return [];
    return this.sortBy(data);
  },
  async getSpecialists(
    academicyearId,
    providerId,
    centerId,
    municipalityId,
    locationtypeId,
    locationId,
    disciplineTypeId
  ) {
    const { status, data } = await http.get(
      `api/provider/${academicyearId}/specialists/`,
      {
        params: {
          providerId: providerId,
          centerId: centerId,
          municipalityId: municipalityId,
          locationtypeId: locationtypeId,
          locationId: locationId,
          disciplineTypeId: disciplineTypeId,
        },
      }
    );
    if (status != 200) return [];
    return this.sortBy(data);
  },
  async getAllBillingCenters() {
    const { status, data: response } = await http.get('api/code/servicecenter');
    return status !== 200 ? [] : response;
  },
  async updateBillingCenter(
    newBillingCenterId,
    disciplineTypeId,
    studentSieId,
    academicYearId,
    companyId
  ) {
    const { status, data: response } = await http.get(
      `${apiUrl}/updatebillingCenter`,
      {
        params: {
          newBillingCenterId,
          disciplineTypeId,
          studentSieId,
          academicYearId,
          companyId,
        },
      }
    );
    return status !== 200 ? {} : response;
  },
  async admissionrejectionhistory(admissionId, pageConfig) {
    const { status, data: response } = await http.get(
      `${apiUrl}/admissionrejectionhistory/${admissionId}`,
      {
        params: pageConfig,
      }
    );
    return status !== 200 ? {} : response;
  },
  async getSchoolByAdmissionId(admissionId) {
    return await http.get(`${apiUrl}/admission/${admissionId}/schools`);
  },
  async getProviderReasons(optionId) {
    return await http.get(`${apiUrl}/admission/providerrejectionreasons`, {
      params: {
        optionId,
      },
    });
  },
  async getProviderDetail(admissionId) {
    return await http.get(`${apiUrl}/admission/${admissionId}/detail`);
  },
  async getSchoolByMunicipality(admissionId, municipalityId) {
    return await http.get(`${apiUrl}/admission/${admissionId}/schoolsBy`, {
      params: {
        municipalityId,
      },
    });
  },
  async getProviderMunicipalities(admissionId) {
    return await http.get(`${apiUrl}/admission/${admissionId}/municipalities`);
  },
  async saveRejectionLinkAdmission(payload) {
    return await http.post(`${apiUrl}/saveRejectionlinkadmission`, payload);
  },
  async getRejectionReasonsByType(type) {
    return await http.get(`${apiUrl}/getthrpyrejectionreasonsbytype/${type}`);
  },

  async denegateReferral(payload) {
    return await http.post(`${apiUrl}/denegatereferral`, payload);
  },
  async replaceServiceRejectionFile(payload) {
    return await http.post(`${apiUrl}/replaceservicerejectionfile`, payload);
  },
  async ReferralUnlink(payload) {
    return await http.post(`${apiUrl}/unlink`, payload);
  },
  async getRecordEvaluationFilterOptions(studentSieId) {
    return await http.get(
      `${apiUrl}/record/${studentSieId}/evaluation/filteroptions`
    );
  },
  async getRecordEvaluation(studentSieId, params) {
    return await http.get(`${apiUrl}/record/${studentSieId}/evaluation`, {
      params,
    });
  },
  async getRecordHistoryFilterOptions(studentSieId) {
    return await http.get(
      `${apiUrl}/record/${studentSieId}/history/filteroptions`
    );
  },
  async getRecordEvaluationDetail(evaluationId) {
    return await http.get(`${apiUrl}/record/${evaluationId}/evaluation/detail`);
  },
};

// admission
export const createAdmissionForOtherService = async (data) => {
  return await http.post(
    `${apiUrl}/admission/createadmissionforotherservices`,
    data
  );
};

export const createReferralOtherServices = async (data) => {
  return await http.post(
    `${apiUrl}/admission/createreferralforotherservices`,
    data
  );
};

export const confirmAdmission = async (data) => {
  return await http.post(`${apiUrl}/confirmadmission`, data);
};

export const updateAdmission = async (data) => {
  return await http.post(`${apiUrl}/updateadmission`, data);
};

export const getAdmissionInfo = (admissionId) => {
  return http.get(`${apiUrl}/infoforadmission/${admissionId}`);
};

export const getAdmissionLocations = (admissionId, municipalityId) => {
  return http.get(`${apiUrl}/locations/${admissionId}/${municipalityId}`);
};

export const getAdmissionCenters = (
  admissionId,
  municipalityId,
  locationTypeId
) => {
  return http.get(
    `${apiUrl}/centers/${admissionId}/${municipalityId}/${locationTypeId}`
  );
};

export const getAdmissionMunicipalities = (admissionId, locationTypeId) => {
  return http.get(`${apiUrl}/municipalities/${admissionId}/${locationTypeId}`);
};

export const getAdmissionRegions = (admissionId, locationTypeId) => {
  return http.get(`${apiUrl}/regions/${admissionId}/${locationTypeId}`);
};

export const getAdmissionDistricts = (
  admissionId,
  regionId,
  locationTypeId
) => {
  return http.get(
    `${apiUrl}/districts/${admissionId}/${regionId}/${locationTypeId}`
  );
};

export const getAdmissionSchools = (
  admissionId,
  districtId,
  locationTypeId
) => {
  return http.get(
    `${apiUrl}/schools/${admissionId}/${districtId}/${locationTypeId}`
  );
};

export const getStudentReferralAdmision = (admissionId) =>
  http.get(`${apiUrl}/studentrefferaladmission/${admissionId}`);

export const getStudentReferralAdmisionBySie = (
  studentSieId,
  disciplineTypeId,
  academicYearId
) =>
  http.get(
    `${apiUrl}/studentrefferaladmission/bystudentsie/${studentSieId}/${disciplineTypeId}/${academicYearId}`
  );

export const getStudentReferralAdmissionInfo = (
  studentSieId,
  disciplineTypeId,
  academicYearId
) =>
  http.get(
    `${apiUrl}/studentrefferaladmission/getadmissioninfo/${studentSieId}/${disciplineTypeId}/${academicYearId}`
  );

export const getCodeExecutionLevelArchieved = () =>
  providerApi.get('api/providers/interventionplan/executionlevelarchieved');

export const getEvaluationDates = (studentSieId) =>
  providerApi.get(
    `api/providers/interventionserviceresultsummary/evaluationdates/${studentSieId}`
  );

export const getServiceResultSummary = (params) =>
  providerApi.get('api/providers/interventionserviceresultsummary', { params });

export const getServiceResultSummaryHistory = (params) =>
  providerApi.get(`api/providers/interventionserviceresultsummary/history`, {
    params,
  });

export const getResultSummaryForRP = (params) =>
  providerApi.get(
    `api/providers/interventionserviceresultsummary/resultsummaryforrp`,
    {
      params,
    }
  );

export const saveResultSummarySpecialistRecommendation = (payload) =>
  providerApi.post(
    'api/providers/interventionserviceresultsummary/savesummaryspecialistrecommendation',
    payload
  );

export const certifyServiceResultSummary = (payload) =>
  providerApi.put(
    'api/providers/interventionserviceresultsummary/certifyresultsummary',
    payload
  );

export const getSpecialistsForAssignment = (
  admissionId,
  locationFiscalYearId,
  studentSieId,
  specialistId
) => {
  return http.get(
    `${apiUrl}/getadmissionspecialistsforassignment?locationFiscalYearId=${locationFiscalYearId}&admissionId=${admissionId}&studentSieId=${studentSieId}&boundSpecialistId=${specialistId}`
  );
};

export const saveAssignment = async (data) => {
  return await http.post(`${apiUrl}/saveassignment`, data);
};

export const canUserLinkSpecialist = async (specialistId) => {
  return await http.get(
    `${apiUrl}/canUserLinkSpecialist?specialistId=${specialistId}`
  );
};

export const getDropReasons = async (
  typeId,
  statusId,
  isEducationalService
) => {
  return await http.get(
    `api/thrpyadmission/admissiondropreasons/${typeId}/${statusId}/?isEducationalService=${isEducationalService}`
  );
};

export const getAdmissionManagementMunicipalities = async (
  academicYearId,
  companyId
) => {
  return await http.get(
    `api/thrpyadmission/admissionmanagementmunicipality/${academicYearId}`,
    {
      params: {
        companyId,
      },
    }
  );
};

/**
 *
 * @params { admissionId, requestId, disciplineTypeId } model
 */
export const approveProvisionalRemedyRequest = async (model) => {
  return await http.post(
    `${apiUrl}/approveprovisionalremedyrequest/${model.admissionId}/${model.requestId}/${model.disciplineTypeId}`,
    {
      params: model,
    }
  );
};

export const getBlogCommentTypes = () =>
  http.get(`${apiUrl}/requestservice/blog/commenttypes`);

export const addBlogItem = (requestServiceId, payload) =>
  http.post(`${apiUrl}/requestservice/blog/${requestServiceId}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getBitacoraItems = (requestServiceId) =>
  http.get(`${apiUrl}/requestservice/blog/${requestServiceId}`);

export const deleteBitacoraItems = (requestServiceId) =>
  http.delete(`${apiUrl}/requestservice/blog/${requestServiceId}`);

export const getStudentServiceOffering = (params) => {
  return http.get(`${apiUrl}/serviceOffering`, { params });
};

export const getSpecialistInfo = (specialistId, disciplineTypeId) =>
  providerApi.get(
    `api/providers/specialists/${specialistId}/${disciplineTypeId}/specialistLicenceInfo`
  );

export const specialistsList = async ({
  fiscalYearId,
  providerId,
  disciplineTypeId,
  validateUserProfile,
  validateLicense,
}) =>
  await providerApi.get('/api/providers/specialists/list', {
    params: {
      fiscalYearId,
      providerId,
      disciplineTypeId,
      validateUserProfile,
      validateLicense,
    },
  });

export const getLastAdmission = async (params) => {
  return await http.get(`api/thrpyadmission/last`, {
    params: params,
  });
};

export const getRecord = async (studentServiceId) => {
  return await http.get(`${apiUrl}/${studentServiceId}/record`);
};

export const getAcademicYearWithDocuments = async (studentSieId) => {
  return await http.get(
    `${apiUrl}/${studentSieId}/disciplines/academicYears-with-documents`
  );
};

export const getRecordDisciplines = async (studentSieId, academicYearId) => {
  return await http.get(
    `${apiUrl}/${studentSieId}/${academicYearId}/disciplines`
  );
};

export const getRecordDisciplineDocumentTypes = async (
  studentSieId,
  academicYearId,
  disciplineTypeId
) => {
  return await http.get(
    `${apiUrl}/${studentSieId}/${academicYearId}/disciplines/${disciplineTypeId}/documentTypes`
  );
};

export const getLastDiagnosis = async (studentSieId, disciplineTypeId) => {
  return await http.get(
    `${apiUrl}/lastdiagnosis/${studentSieId}/${disciplineTypeId}`
  );
};

export const returnAdmissionToPreviousStatus = async (admissionId) => {
  return await http.put(
    `api/studentreferrals/returnadmissionstatustoprevious/${admissionId}`
  );
};

export const saveStudentDiagnosis = async (payload) => {
  return await http.post(`${apiUrl}/diagnosis/`, payload);
};

export const getRecordDisciplineDocuments = async (studentSieId, params) => {
  return await http.get(`${apiUrl}/${studentSieId}/disciplines/documents`, {
    params,
  });
};

export const searchDiagnosticsExcludingStudent = (studentSieId, term = '') =>
  http.get(`${apiUrl}/${studentSieId}/diagnostics-excluding`, {
    params: { term },
  });
